import React, { useState, useEffect } from 'react';
import { VictoryChart, VictoryBar, VictoryTheme, VictoryAxis } from "victory";
import { getCabinUsage } from '../../../utils/PowerApiService';
import styled from 'styled-components'

const Header = styled.span`
    font-size: 20px;
    font-weight: bold;
    margin-left: 10px;
    margin-top: 15px;
`;

const UsageCabin = props => {

    const [loading, setLoading] = useState(false);
    const [minY, setMinY] = useState(0.0);
    const [maxY, setMaxY] = useState(0.0);
    const [chartData, setChartData] = useState(null);

    async function getUsages() {
        setLoading(true);

        try {
            var prices = await getCabinUsage();
            setChartData(prices.data);
            setMinY(prices.minY);
            setMaxY(prices.maxY);

        }
        catch (error) {
            console.error('Feil ved henting av tibber data:', error);
        }


        setLoading(false);
    }

    useEffect(() => {

        getUsages();
    }, []);

    if (loading) {
        return (
            <div className="weather">
                <div className="weatherSpinner"></div>
            </div>
        );
    }
    else {
        return (
            <div>
                <Header>Rauneliveien 12</Header>
                <VictoryChart
                    minDomain={{ y: minY }}
                    maxDomain={{ y: maxY }}
                    theme={VictoryTheme.material}
                    padding={{ top: 10, bottom: 60, left: 40, right: 40 }}
                    height={200}
                >
                    <VictoryBar
                        style={{
                            data: { stroke: "#c43a31" },
                            parent: { border: "1px solid #ccc" }
                        }}
                        data={chartData}
                        interpolation="natural"
                    />
                    <VictoryAxis dependentAxis
                    />

                    <VictoryAxis
                        style={{ tickLabels: { angle: 90, transform: 'translate(10, 10)' } }}
                    />
                </VictoryChart>
            </div>
        );
    }
};

export default UsageCabin;
